import {Component} from '@angular/core';
import {jurorList} from '@dashboard/welcome/jury-data';
import {NgOptimizedImage, CommonModule} from '@angular/common';

@Component({
  selector: 'app-jury-section',
  templateUrl: './jury-section.component.html',
  styleUrls: ['./jury-section.component.scss'],
  standalone: true,
  imports: [CommonModule, NgOptimizedImage],
})
export class JurySectionComponent {
  jurorList = jurorList;
}
